import { queryOptions } from '@tanstack/react-query'

import {
  fetchOwners,
  fetchProvisionOptions,
  fetchTenant,
  fetchTenants,
} from '#admin/features/platform/tenants/api.ts'

/**
 * The tenant list.
 *
 * A short `staleTime` — unlike the module manifest, which changes on the order of months, this
 * changes the moment somebody provisions an edition, and the person watching is usually the
 * person who just did it.
 */
export const tenantsQuery = () =>
  queryOptions({
    queryKey: ['platform', 'tenants'],
    queryFn: ({ signal }) => fetchTenants(signal),
    staleTime: 10_000,
  })

/** One tenant. Keyed under the list, so invalidating the list refreshes every detail with it. */
export const tenantQuery = (tenantId: string) =>
  queryOptions({
    queryKey: ['platform', 'tenants', tenantId],
    queryFn: ({ signal }) => fetchTenant(tenantId, signal),
    staleTime: 10_000,
  })

/**
 * The plans and event series the provisioning form offers.
 *
 * A long `staleTime`: a plan is a commercial artifact that changes when somebody signs a
 * contract, not per navigation.
 */
export const provisionOptionsQuery = () =>
  queryOptions({
    queryKey: ['platform', 'options'],
    queryFn: ({ signal }) => fetchProvisionOptions(signal),
    staleTime: 5 * 60_000,
  })

export const ownersQuery = (tenantId: string) =>
  queryOptions({
    queryKey: ['platform', 'tenants', tenantId, 'owners'],
    queryFn: ({ signal }) => fetchOwners(tenantId, signal),
    staleTime: 30_000,
  })
